<div class="form-group">
  <label for="name" class="col-sm-2 control-label">Name</label>
  <div class="col-sm-10">
    <input type="text" class="form-control" name="name" id="name" placeholder="Supplier Name"
           [(ngModel)]="supplier.name" required>
  </div>
</div>

<div class="form-group">
  <label for="name" class="col-sm-2 control-label">Domain</label>
  <div class="col-sm-10">
    <app-domain-select [model]="supplier" [required]="false"></app-domain-select>
  </div>
</div>

<app-shared-address [model]="supplier"></app-shared-address>

<app-shared-contact-details [model]="supplier"></app-shared-contact-details>

<div class="form-group">
  <div class="col-sm-offset-2 col-sm-10 text-right">
    <button type="submit" class="btn btn-success">Save</button>
  </div>
</div>
